import ConfirmationModal from 'components/common/ConfirmationMessage';
import { ListLayout } from 'components/common/ListLayout';
import TableHeaderItem from 'components/common/ListLayout/TableHeaderItem';
import moment from 'moment';
import React, { useMemo } from 'react'
import toast from 'react-hot-toast';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { InterpreterDashboardSelector } from 'slices/interpreter/dashboardSlice';
import { fetchInterpreterDashboardAppointments } from 'slices/interpreter/dashboardSlice';

const BASE_PARAMS = { type: [0, 1, 4], pageLength: 10, sortBy: 'date', sortDirection: 'desc' };

const LUNCH_STYLE = { background: '#2e7d3222' };
const LUNCH_EYE_STYLE = { background: '#2e7d32' };
const DAY_OFF_STYLE = { background: '#fd7e1433' };
const DAY_OFF_EYE_STYLE = { background: '#fd7e14' };

const ListTable = ({ data, lunchRecords = [], showLunch = true, filtration, hidePagination = false, hideHeader = false, heading, link }) => {
    const dispatch = useDispatch();
    const [addForm, setAddForm] = React.useState({
        show: false,
        item: {}
    });
    const refAddutton = React.useRef(null);

    const [selectedItems, setSelectedItems] = React.useState([]);
    const [selectAll, setSelectAll] = React.useState(false);
    const [declineModal, setDeclineModal] = React.useState(
        {
            show: false,
            item: {}
        }
    );
    const [currentPage, setCurrentPage] = React.useState(1);
    const [searchTerm, setSearchTerm] = React.useState("");
    const [sortConfig, setSortConfig] = React.useState({
        sortBy: 'date',
        sortDirection: 'desc',
    });
    const [sortFields, setSortFields] = React.useState([]);

    const [actionAccept, setActionAccept] = React.useState({
        show: false,
        item: {}
    });
    const { last_page: totalPages, current_page, per_page: pageLength, total } = useSelector(InterpreterDashboardSelector);

    const handleAddScheduleListPopUp = (item) => {
        setAddForm({
            show: true,
            item,
        });
    };
    const submitCallback = (status, message) => {
        if (status) {
            toast.success(message, {
                className: "successToast",
            })
            setSelectedItems([]);
            setSelectAll(false)
            hideConfirmDialog()
        }
        else {
            toast.error(message,
                {
                    className: "errorToast",
                }
            );
        }
    };
    const showConfirmDialog = () => {
        setDeclineModal(true);
        return
    };
    const hideConfirmDialog = () => {
        setDeclineModal(false);
    }
    const handleDeclineConfirm = () => {
        // dispatch(declineVendorJobs({ schedule_id: declineModal?.item?.id }, submitCallback))
    }
    const handleChange = (e) => {
        const id = e.target.dataset.value
        setSelectedItems(
            selectedItems.includes(id) ?
                selectedItems.filter((item) => item != id) :
                [...selectedItems, id]
        )
    };

    //#region TABLE HEAD 
    const renderTableHeader = React.useCallback(() => {
        const callBack = (dir, sortBy) => {
            setSortConfig({ sortBy, sortDirection: dir });
            dispatch(fetchInterpreterDashboardAppointments(currentPage, {
                ...BASE_PARAMS,
                ...filtration,
                sortBy,
                sortDirection: dir,
                search: searchTerm,
            }));
        }

        return (
            <tr>
                <th>#</th>
                <th>
                    <TableHeaderItem
                        title="appid"
                        sortBy="appid"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>
                <th className="col-2">
                    <TableHeaderItem
                        title="Language"
                        sortBy="language"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>
                <th className="col-2">
                    <TableHeaderItem
                        title="Type"
                        sortBy="type"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>
                <th className="col-1">
                    <TableHeaderItem
                        title="Status"
                        sortBy="status"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>
                <th className="col-3">
                    <TableHeaderItem
                        title="Meeting Date & Time"
                        sortBy="meeting_date"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>
                <th className="col-2">
                    <TableHeaderItem
                        title="School"
                        sortBy="school"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>
                <th className="col-2">
                    <TableHeaderItem
                        title="Creation Date"
                        sortBy="created_at"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>
            </tr>
        )
    }, [selectAll, searchTerm, sortFields, currentPage, sortConfig, selectedItems, filtration]);
    //#endregion


    //#region TABLE BODY

    const renderTableContent = React.useCallback(() => {
        return (
            <>
                {data?.map((item, index) => (
                    // eslint-disable-next-line eqeqeq
                    item?.type == 4
                        ? <DayOffRow key={item?.id} item={item} />
                        : <AppointmentListItem key={item?.id} item={item} index={index} link={link} handleAcceptButton={handleAcceptButton} handleDeclineShow={handleDeclineShow} current_page={current_page} pageLength={pageLength} />
                ))}
                {showLunch && lunchRecords?.map((lunch) => (
                    <LunchRow key={lunch?.id} lunch={lunch} />
                ))}
            </>
        )
    }, [selectedItems, data, lunchRecords, showLunch]);

    //#endregion


    const handleAcceptButton = React.useCallback((id) => {
        setActionAccept({
            show: true,
            item: { id },
        });
    }, [])

    const handleCloseActionButton = React.useCallback((id) => {
        setActionAccept({
            show: false,
            item: {}
        })
    }, [])

    const handleDeclineShow = React.useCallback((id) => {
        setDeclineModal({
            show: true,
            item: { id },
        });
    }, [])


    return (
        <div className='mt-4'>
            <ListLayout
                heading={heading}
                key={JSON.stringify(filtration)}
                time={false}
                fullMainHead={'ms-3'}
                title=""
                renderTableHeader={renderTableHeader}
                renderTableContent={renderTableContent}
                fetchList={fetchInterpreterDashboardAppointments}
                filtration={filtration}
                selectedItems={selectedItems}
                handleDeclineConfirm={handleDeclineConfirm}
                refAddutton={refAddutton}
                addForm={addForm}
                showConfirmDialog={showConfirmDialog}
                handleAddPopUp={handleAddScheduleListPopUp}
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
                searchPlaceholder="Search in this table ..."
                addButtonDisabled={true}
                totalPages={totalPages}
                noOfItems={total}
                sortConfig={sortConfig}
                hidePagination={hidePagination}
                hideHeader={hideHeader}
            >
                {declineModal.show && <ConfirmationModal onClose={hideConfirmDialog} isOpen={declineModal?.show} onConfirm={handleDeclineConfirm} confirmationText="Are you sure you want to Decline?" />}
            </ListLayout>
        </div>
    )
}


const AppointmentListItem = React.memo(({
    item, index, current_page, pageLength, link
}) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const serial = useMemo(() => {
        return index + 1 + (current_page - 1) * pageLength;
    }, [current_page, pageLength]);

    const getBackgroundStyle = (status) => {
        if (status === 'assigned') {
            return { background: '#785c9933' };
        } else if (status === 'open') {
            return { background: '#ffb82a33' };
        } else if (status === 'dnc') {
            return { background: '#3176a033' };
        } else if (status === 'cnc') {
            return { background: '#9623e033' };
        } else if (status === 'completed') {
            return { background: '#1c2b2c33' };
        } else if (status === 'cancelled') {
            return { background: '#e33a3133' };
        } else if (status === 'vendor_declined') {
            return { background: '#ff000033' }
        } else if (status === 'declined') {
            return { background: '#ff000033' }
        } else if (status === 'pending') {
            return { background: '#3176a033' }
        } else if (status === 'day_off') {
            return DAY_OFF_STYLE;
        }
    };
    const getEyeStyle = (status) => {
        if (status === 'assigned') {
            return { background: '#785c99' };
        } else if (status === 'open') {
            return { background: '#ffb82a' };
        } else if (status === 'dnc') {
            return { background: '#3176a0' };
        } else if (status === 'cnc') {
            return { background: '#9623e0' };
        } else if (status === 'completed') {
            return { background: '#1c2b2c' };
        } else if (status === 'cancelled') {
            return { background: '#e33a31' };
        } else if (status === 'vendor_declined') {
            return { background: '#b51a12' }
        } else if (status === 'declined') {
            return { background: '#b51a12' }
        } else if (status === 'pending') {
            return { background: '#3176a0' }
        } else if (status === 'day_off') {
            return DAY_OFF_EYE_STYLE;
        }
    };
    const typeLabels = { 0: "Interpreting Request", 1: "After Hours Request", 2: "Bilingual Exams Request", 4: "Day Off", "0": "Interpreting Request", "1": "After Hours Request", "2": "Bilingual Exams Request", "4": "Day Off" };
    const rawDatetime = item?.date + " " + item?.start_time;
    const formattedDate = moment(rawDatetime, 'YYYY-MM-DD HH:mm:ss').format('MMM D, YYYY HH:mm:ss');
    // Use display_status for colour/label — declined appointments that belong to another
    // interpreter appear as 'open' (yellow) since they are available for this interpreter
    const displayStatus = item?.display_status ?? item?.status;
    return (
        <tr>
            <td className='p-0' style={getBackgroundStyle(displayStatus)}>
                <div className='eye_area' style={getEyeStyle(displayStatus)}>
                    <Link to={`/interpreter/appointments/view/${item?.id}`}><i class="fa-solid fa-eye"></i></Link>
                </div>
            </td>
            <td style={getBackgroundStyle(displayStatus)}>
                <Link className='link_preview' to={`/interpreter/appointments/view/${item?.id}`}>
                    {item?.appid || 'N/A'}
                </Link>
            </td>
            <td style={getBackgroundStyle(displayStatus)}>
                {item?.language?.name || 'N/A'}
            </td>
            <td style={getBackgroundStyle(displayStatus)}>
                {typeLabels[item?.type] || 'N/A'}
            </td>
            <td style={getBackgroundStyle(displayStatus)}>
                {displayStatus || 'N/A'}
            </td>
            <td style={getBackgroundStyle(displayStatus)}>
                {item?.date ? formattedDate : 'N/A'}
            </td>
            <td style={getBackgroundStyle(displayStatus)}>
                {item?.school?.name || 'N/A'}
            </td>
            <td style={getBackgroundStyle(displayStatus)}>
                {item?.created_at ? moment(item.created_at, 'YYYY-MM-DD HH:mm').format('MMM D, YYYY HH:mm') : 'N/A'}
            </td>
        </tr>
    )
})
const DayOffRow = ({ item }) => {
    const dateLabel = item?.date
        ? moment(item.date, 'YYYY-MM-DD').format('MMM D, YYYY')
        : 'N/A';
    const interpreterName = item?.interpreter?.user?.name ?? 'N/A';

    return (
        <tr>
            <td className='p-0' style={DAY_OFF_STYLE}>
                <div className='eye_area' style={DAY_OFF_EYE_STYLE}>
                    <i className="fa-solid fa-ban"></i>
                </div>
            </td>
            <td style={DAY_OFF_STYLE}></td>
            <td style={DAY_OFF_STYLE}>{interpreterName}</td>
            <td style={DAY_OFF_STYLE}>Day Off</td>
            <td style={DAY_OFF_STYLE}>—</td>
            <td style={DAY_OFF_STYLE}>{dateLabel}</td>
            <td style={DAY_OFF_STYLE}>—</td>
            <td style={DAY_OFF_STYLE}>—</td>
        </tr>
    );
};

const LunchRow = ({ lunch }) => {
    const dateLabel = lunch?.date
        ? moment(lunch.date, 'YYYY-MM-DD').format('MMM D, YYYY')
        : 'N/A';
    const timeLabel = lunch?.start_time && lunch?.end_time
        ? `${moment(lunch.start_time, 'HH:mm').format('h:mm A')} – ${moment(lunch.end_time, 'HH:mm').format('h:mm A')}`
        : lunch?.start_time
            ? moment(lunch.start_time, 'HH:mm').format('h:mm A')
            : 'N/A';

    return (
        <tr>
            <td className='p-0' style={LUNCH_STYLE}>
                <div className='eye_area' style={LUNCH_EYE_STYLE}>
                    <i className="fa-solid fa-utensils"></i>
                </div>
            </td>
            <td style={LUNCH_STYLE}>LUNCH</td>
            <td style={LUNCH_STYLE}>{lunch?.interpreter_name || 'N/A'}</td>
            <td style={LUNCH_STYLE}>Lunch Break</td>
            <td style={LUNCH_STYLE}>On Lunch</td>
            <td style={LUNCH_STYLE}>{dateLabel} {timeLabel}</td>
            <td style={LUNCH_STYLE}>—</td>
            <td style={LUNCH_STYLE}>—</td>
        </tr>
    );
};

export default ListTable